import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { _throw } from 'rxjs/observable/throw';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { AccountObjectFacade } from '../account-object/account-object.facade';
import { AccountObjectStoreFacade } from '../account-object/account-object.store-facade';
import { JobDataApiFacade } from './job-data.api-facade';
import { JobData } from './job-data.model';

export abstract class JobDataFacade<T extends JobData, A extends JobDataApiFacade<T>, S extends AccountObjectStoreFacade<T>> extends AccountObjectFacade<T, A, S> {

    // @todo this method should be called syncOne but the additional argument for jobId breaks the interface. Ideally
    // we should do a refactor which would allow this but there isn't time.
    syncOneItem(accountId: string, jobId: string, id: string, options?: ApiRequestOptions): Observable<any> {

        if (this.appFacade.objects.isChangePending(id)) {
            return of(undefined);
        }

        return this.api.get(accountId, jobId, id, options)
            .catch(error => {
                if (error.status === 404) {
                    this.store.get(id)
                        .take(1)
                        .do(item => {
                            this.store.remove(item, {persistable: true, restful: false});
                        })
                        .subscribe(item => undefined);
                    return of(undefined);
                }
                return _throw(error);
            })
            .map(object => object && this.setAccountId(object, accountId))
            .do(object => object && this.insertIfFresher(object));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-data/job-data.facade.ts